import { useGetSystemProperty } from '@akin-home/system-properties-react';
import { InfoVideoName } from '../types';

export const useCalendarInfoVideo = () =>
  useGetSystemProperty(InfoVideoName.CALENDAR_SCREEN);

export const useContactsInfoVideo = () =>
  useGetSystemProperty(InfoVideoName.CONTACTS_SCREEN);

export const useGoalsInfoVideo = () =>
  useGetSystemProperty(InfoVideoName.GOALS_SCREEN);

export const useMealsInfoVideo = () =>
  useGetSystemProperty(InfoVideoName.MEALS_SCREEN);

export const useChecklistsInfoVideo = () =>
  useGetSystemProperty(InfoVideoName.CHECKLIST_SCREEN);
